import { createSelector } from 'reselect'

export const selectUser = (state) => state.user

export const selectCanAccessSetup = createSelector(selectUser, (user) => {
  if (!user) return false
  return user.role === 'Support Admin'
})
